<div class="alert-dialog__overlay" (click)="onCancel()">
  <div
    class="alert-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-message"
    data-testid="alert-dialog"
    (click)="$event.stopPropagation()"
  >
    <h2 id="alert-dialog-title" class="alert-dialog__title">{{ title }}</h2>

    @if (message) {
      <p id="alert-dialog-message" class="alert-dialog__message">{{ message }}</p>
    }
    @if (description) {
      <p class="alert-dialog__description">{{ description }}</p>
    }
    <!-- Para descrições com formatação (ex.: negrito), que o input de texto não comporta. -->
    <div class="alert-dialog__description"><ng-content /></div>

    <div class="alert-dialog__actions">
      <button
        type="button"
        class="alert-dialog__btn alert-dialog__btn--cancel"
        data-testid="alert-dialog-cancel"
        (click)="onCancel()"
      >
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        class="alert-dialog__btn alert-dialog__btn--confirm"
        data-testid="alert-dialog-confirm"
        (click)="onConfirm()"
      >
        <span>{{ confirmLabel }}</span>
        @if (showConfirmIcon) {
          <svg
            class="alert-dialog__btn-icon"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M11.6994 4.23816L10.8 5.13753L15.0394 9.37503H2.5V10.625H15.0394L10.8006 14.8632L11.6994 15.7619L17.0119 10.4494L17.4412 10L17.0119 9.55066L11.6994 4.23816Z"
              fill="white"
            />
          </svg>
        }
      </button>
    </div>
  </div>
</div>
